import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { MAT_CARD_CONFIG } from '@angular/material/card';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideRouter,
  Routes,
  withComponentInputBinding,
  withInMemoryScrolling,
  withRouterConfig,
} from '@angular/router';
import { environment } from '@env/environment';
import { provideTransloco } from '@jsverse/transloco';
import { provideNgIdleKeepalive } from '@ng-idle/keepalive';
import { TranslocoHttpLoader } from './transloco-loader';
import { AuthModule } from './auth.module';
import {CARD_OPTIONS, DIALOG_OPTIONS, FORM_FIELD_OPTIONS} from '@core/constants/constants.component';

export type CoreOptions = {
  routes: Routes;
};

export function provideCore({ routes }: CoreOptions) {
  return [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimationsAsync(),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withRouterConfig({ onSameUrlNavigation: 'reload' }),
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      }),
    ),

    importProvidersFrom(AuthModule),
    provideNgIdleKeepalive(),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { ...FORM_FIELD_OPTIONS },
    },
    {
      provide: MAT_CARD_CONFIG,
      useValue: {
        ...CARD_OPTIONS,
      },
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        ...DIALOG_OPTIONS,
      },
    },

    // TO DO - MIGRATE INTERCEPTORS to Interceptors Functions
    // withInterceptors([
    //   oktaInterceptor,
    //   azureAllowedOrgInterceptor,
    //   authInterceptor,
    //   spinnerInterceptor,
    //   timeoutInterceptor,
    // ]),

    provideTransloco({
      loader: TranslocoHttpLoader,
      config: {
        availableLangs: [
          { id: 'en', label: 'English' },
          { id: 'es', label: 'Spanish' },
          { id: 'fr', label: 'French' },
          { id: 'ge', label: 'Germany' },
        ],
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        fallbackLang: 'en',
        defaultLang: 'en',
        missingHandler: {
          useFallbackTranslation: false,
        },
        prodMode: environment.production,
      },
    }),
  ];
}
